<mat-card>
  <mat-card-header>
    <mat-card-title>Business Skills</mat-card-title>
  </mat-card-header>

  <mat-card-content class="m-t-1">

    <p>Provide details of your (and your spouse's) total net business, investment and personal assets held during the two most recent fiscal years (in $AUD)</p>

    <app-text-input [control]="businessSkillsForm.controls.assetsRecent"
       label="Most Recent Year (in AUD)" shortLabel="Most Recent Year" prefix="$" type="number"></app-text-input>
    <app-text-input [control]="businessSkillsForm.controls.assetsPrior"
       label="Year Prior (in AUD)" shortLabel="Year Prior"
                    prefix="$" type="number"></app-text-input>
    <app-text-input [control]="businessSkillsForm.controls.assetsTransferred"
       label="What is the net value of assets that you would be able to transfer to Australia within 2 years of the grant of a visa (in $AUD)?" shortLabel="Assets Transferred"
                    prefix="$" type="number"></app-text-input>
    
    <app-select-input [control]="businessSkillsForm.controls.businessYears"
      [lookupItems]="businessExperience" shortLabel="Business Years"
      label="How many years of business experience can you demonstrate" 
      placeholder="Select number of years">
    </app-select-input>

    <app-select-input [control]="businessSkillsForm.controls.investmentYears"
      [lookupItems]="businessExperience" shortLabel="Investment Years"
      label="How many years of investment experience can you demonstrate" 
      placeholder="Select number of years">
    </app-select-input>
    
    <app-text-area [control]="businessSkillsForm.controls.businessHistory"
       label="Describe your business or investment history" shortLabel="Business History"></app-text-area>
    
    <app-radio-input [control]="businessSkillsForm.controls.hasPatents"
        label="Do you have any registered patents or have a registered design?"
        [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
    </app-radio-input>
    @if (businessSkillsForm.controls.hasPatents.value === 'true') {
      <app-text-area [control]="businessSkillsForm.controls.patentDetails"
        label="Provide Details" shortLabel="Patent Details"></app-text-area>
    }
    
    <app-radio-input [control]="businessSkillsForm.controls.hasTrademarks"
       label="Do you have any registered trademarks?"
       [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
      </app-radio-input>
    @if(businessSkillsForm.controls.hasTrademarks.value === 'true'){
      <app-text-area [control]="businessSkillsForm.controls.trademarkDetails"
       label="Provide Details" shortLabel="Trademark Details"></app-text-area>
    }
    
    <app-radio-input [control]="businessSkillsForm.controls.hasJointVenture"
       label="Do you have any joint venture agreements in place with other business people or businesses?"
       [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
      </app-radio-input>
    @if(businessSkillsForm.controls.hasJointVenture.value === 'true'){
      <app-text-area [control]="businessSkillsForm.controls.joinVentureDetails"
       label="Provide Details" shortLabel="Joint Venture Details"></app-text-area>
    }
    
    <app-radio-input [control]="businessSkillsForm.controls.isExport"
       label="Are you involved in export trade?"
       [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
      </app-radio-input>
    @if(businessSkillsForm.controls.isExport.value === 'true'){
      <app-text-area [control]="businessSkillsForm.controls.exportDetails"
       label="Provide Details" shortLabel="Export Details"></app-text-area>
    }
    
    <div class="label-with-tooltip">
    <span>Does your main business(es) meet the definition of a 'gazelle business'?</span>
        <button mat-icon-button 
          matTooltip="A high-growth company that is increasing its revenues by at least 20% annually for four years or more, starting from a revenue base of at least $1 million. This growth pace means that the company has effectively doubled its revenues over a four-year period." tabindex="-1" type="button">
          <mat-icon>info</mat-icon>
        </button>
    </div>
    <app-radio-input [control]="businessSkillsForm.controls.isGazelle"
       label=""
       [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
    </app-radio-input>
    @if(businessSkillsForm.controls.isGazelle.value === 'true'){
      <app-text-area [control]="businessSkillsForm.controls.gazelleDetails"
       label="Provide Details" shortLabel="Gazelle Details"></app-text-area>
    }
    
    <app-radio-input [control]="businessSkillsForm.controls.receivedFundingGrants"
       label="Have you received any funding grants for innovation?"
       [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
      </app-radio-input>
    @if(businessSkillsForm.controls.receivedFundingGrants.value === 'true'){
      <app-text-area [control]="businessSkillsForm.controls.fundingGrantDetails"
       label="Provide Details" shortLabel="Funding Grant Details"></app-text-area>
    }
    
    <app-radio-input [control]="businessSkillsForm.controls.receivedFundingCapital"
       label="Have you received any venture capital funding?"
       [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
      </app-radio-input>
    @if(businessSkillsForm.controls.receivedFundingCapital.value === 'true'){
      <app-text-area [control]="businessSkillsForm.controls.fundingCapitalDetails"
       label="Provide Details" shortLabel="Funding Capital Details"></app-text-area>
    }
    
    <!-- 

      <div class="question-container">
        <label>Please provide an explanation of why {{applicantText.you.toLowerCase()}} would like to study in Australia and what {{applicantText.you.toLowerCase()}} would like to study</label>
        <app-text-area
          label="Study Reasons"
          >
        </app-text [control]="applicantDetailsForm.controls.studyReasons"
          -area>
      </div>



        <app-radio-input 
                label="During the previous 4 years, have you had an ownership interest and management involvement in any business?" 
                 
                [options]="[{value [control]="investmentForm.controls.hadOwnership"
                  : 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
          </app-radio-input>
 -->

  </mat-card-content>
</mat-card>